import moment from "moment/moment";
import { useEffect, useState } from "react";
import { Col, Form, Modal, Row, Toast, ToastContainer } from "react-bootstrap";
import { Datepicker } from "vanillajs-datepicker";
import Styles from './TextDate.module.css';
import "/node_modules/vanillajs-datepicker/dist/css/datepicker-bs5.min.css";

export function RandomId(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function AddCommar(param) {
    const value = param;
    if (value === undefined) return value;
    if (isNaN(value)) return value;
    try {
        return (value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    } catch (e) {
        return param;
    }
}

export function DateToText(param) {
    if (param === undefined) return param;

    let date = moment(param, 'YYYY-MM-DDTHH:mm:ss');
    if (!date.isValid()) return '';

    return date.format('DD/MM/YYYY');
}

export function ConvertDateToText(param) {
    if (param === null || param === '') return '-';
    return moment(param).format('DD/MM/YYYY');
}

export function ConvertDateTimeToText(param) {
    if (param === null || param === '') return '-';
    return moment(param).format('DD/MM/YYYY HH:mm');
}

export function ConvertTimeToText(param) {
    if (param === null) return '-';
    return moment(param).format('HH:mm');
}

export function TextDate({ name = 'txt', className = '', placeholder = '', value = undefined
    , onChange = undefined, readOnly = false ,disabled=false, required =false }) {
        
    useEffect(() => {
        let txt_date = document.querySelector(`[name=${name}]`)
        if (txt_date.classList.contains("datepicker-input")) return;

        new Datepicker(txt_date, {
            autohide: true,
            format: "dd/mm/yyyy",
            todayBtn: true,
            clearBtn: true,
            todayBtnMode: 1,
            todayHighlight: true,
        });

        txt_date.addEventListener('changeDate', (event) => onChange(event));
        // eslint-disable-next-line
    }, [])

    return (
        <div className={`${Styles.has_date} ${className}`}>
            <input type="text" name={name} className={`form-control ${className} ${Styles.design_input} `} 
            placeholder={placeholder} value={value} onChange={(event) => onChange(event)}
            maxLength='10' readOnly ={readOnly} 
            pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/(19|20|30)\d{2}$"
            disabled={disabled} 
            required={required} />
            <i className={`fa-solid fa-calendar-days ${Styles.feedback}`}></i>
        </div>

    );
}

export function ButtonUploadFile({ name = 'upload',
    className,
    label = 'upload',
    value = undefined,
    defaultPreview = undefined,
    onChange = undefined,
    readOnly = false,
    required }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [selectFile, setSelectFile] = useState(undefined);
    const [preview, setPreview] = useState(defaultPreview);
    const [fileType, setFileType] = useState(undefined);

    useEffect(()=>{
        const fetchData = async()=>{
            console.log('selectFile=',selectFile);
            if(selectFile === undefined  || selectFile === ''){
                setPreview(defaultPreview);
                const response = await fetch(defaultPreview);
                const tmpBlob = await response.blob();
                setFileType(tmpBlob?.type);

                console.log(defaultPreview);
                console.log(tmpBlob);
            }
        }
        
        fetchData();
            
    },[defaultPreview])

    useEffect(() => {
        if (value === undefined) {
            setPreview(undefined);
            document.querySelector(`input[type=file][name=${name}]`).value = null;
            //document.querySelector(`.${Styles.drop_zone}`).style.display = 'block';
        }
    }, [value])

    useEffect(() => {
        if (!selectFile) {
            setPreview(undefined);
            setFileType(undefined);
            return;
        }
        //console.log(selectFile.type.indexOf('image'));
        //document.querySelector(`.${Styles.drop_zone}`).style.display = 'none';
        const objURl = URL.createObjectURL(selectFile);
        setPreview(objURl);
        setFileType(selectFile?.type);
        if (onChange !== undefined){
            onChange({ target: { name: name + '_image', value: objURl } });
        }
        //return ()=> URL.revokeObjectURL(objURl);
        // eslint-disable-next-line
    }, [selectFile]);

    const handleClearValue = () => {
        setPreview(undefined);
        setFileType(undefined);
        setSelectFile(undefined);
        document.querySelector(`input[type=file][name=${name}]`).value = null;

        if (onChange !== undefined){
            onChange({ target: { name: name, type: 'file', value: '', files: [undefined] } });
            onChange({ target: { name: name + '_image', value: undefined } });
            onChange({ target: { name: name + '_id', value: null } });
        }
            
    }

    const handlefireSelectFile = (event) => {
        if(readOnly){
            return;
        }
        if (preview !== undefined) {
            setShow(true);
            return;
        }
        const input = event.target.querySelector('input');
        if (input !== null)
            input.click();
    }

    const onSelectFile = (event) => {
        if (event.target.files === null || event.target.files.length === 0) {
            setSelectFile(undefined);
            return;
        }

        setSelectFile(event.target.files[0]);

        if (onChange !== undefined)
            onChange(event);
    }

    return (
        <>

            <div className={Styles.UploadFile}>
                {
                    preview && !readOnly &&
                    <button type={'button'} className={"btn btn-danger " + Styles.BtnClearFile} onClick={handleClearValue}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                }

                <button type='button' className={'btn btn-upload-file ' + Styles.BtnUploadFile + ' ' + className} onClick={handlefireSelectFile}>
                    <input type="file" name={name} onChange={onSelectFile}
                        accept="image/*,application/pdf"
                        required={required}/>
                    {
                        !selectFile && !preview &&

                        <>
                            <i className="fa-regular fa-image"></i><br />
                            {label}
                        </>
                    }
                    {
                        ( ((selectFile && fileType?.indexOf('image') > -1)) ||
                        (preview && fileType?.indexOf('image') > -1)) &&
                        <>
                            <img alt='' src={preview} style={{ marginTop: '0', width: 'auto', height: '100%' }} />
                        </>
                    }
                    {
                        ((selectFile && fileType?.indexOf('image') === -1) ||
                        (preview && fileType?.indexOf('image') === -1)) &&
                        <>
                            <img alt='' src={require('images/document-901.png')} style={{ marginTop: '0', width: 'auto', height: '80%' }} />
                            <br />
                            <span>{selectFile?.name}</span>
                        </>
                    }
                </button>
            </div>
            <Modal show={show}  fullscreen={true} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {
                        preview === undefined &&
                        <span>ไม่สามารถแสดงไฟล์ได้</span>
                    }
                    {
                        (preview !== undefined &&
                        fileType?.indexOf('image') > -1) &&
                        <img alt='' src={preview} style={{ marginTop: '0', width: '100%', height: 'auto' }} />
                    }
                    {
                        (preview !== undefined &&
                        fileType?.indexOf('image') === -1) &&
                        <embed alt='' src={preview} style={{ marginTop: '0', width: '100%', height: '500px' }} />
                    }
                    {
                        (preview !== undefined &&
                        fileType === undefined) &&
                        <embed alt='' src={preview} style={{ marginTop: '0', width: '100%', height: '500px' }} />
                    }
                </Modal.Body>
            </Modal>
        </>

    )
}

export function Switch({ name = '', disabled = false, label = '', onChange = undefined, value = '', className = '', required = false }) {
    return (
        <div className={Styles.Switch + ' ' + className}>
            <input type='checkbox' id={'_' + name} name={name} value={value} required={required} onChange={onChange} />
            <label for={'_' + name}>{label}</label>
        </div>
    )
}

//////////////////////////////////////////
export function GenPaging({ page_no = 1, page_count = 1, page_show = 3, onPageChange = undefined }) {
    const [pagination, setPagination] = useState([]);

    const getPaging = () => {
        const max_page = page_show;
        const middle = Math.floor(max_page / 2);

        let tmp_paging = [];

        let start = 1;
        let end = max_page;

        start = page_no - middle;
        start = ((start + max_page - 1) > page_count) ? (page_count - max_page + 1) : start;
        start = (start < 1) ? 1 : start;

        end = start + max_page - 1;
        end = (end > page_count) ? page_count : end;

        for (let i = start; i <= end; i++)
            tmp_paging.push({ page: i });

        setPagination(tmp_paging);
    }

    useEffect(() => {
        getPaging();
    }, [page_no, page_count])

    return (
        <nav aria-label="Page navigation" className="p-0">
            <ul className="pagination justify-content-end mb-0">
                <li className="page-item">
                    <a className="page-link" aria-label="Previous" onClick={(_) => onPageChange(1)}>
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>
                {
                    pagination.map((obj, index) => (
                        <li key={index} className={`page-item ${(parseInt(page_no) === parseInt(obj.page)) ? 'active' : ''}`}><a className={`page-link`} href="#" onClick={(_) => onPageChange(obj.page)}>{obj.page}</a></li>
                    ))
                }

                <li className="page-item">
                    <a className="page-link" aria-label="Next" onClick={(_) => onPageChange(page_count)}>
                        <span aria-hidden="true">&raquo;</span>
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export function DisplayPaging({ rec_start = 1, rec_end = 1, rec_count = 1, onSizeChange = undefined
    , cur_page, size, page_count, onPagingChange = undefined }) {
    return (
        <div className="table bottom-tool pt-3 pb-3">
            <Row>
                <Col className="text-start" >
                    <Form.Label>Showing {rec_start} to {rec_end} of {rec_count} </Form.Label>
                </Col>
                <Col className="text-center">
                    <Form.Label className={'d-inline-block'}>Result per page : </Form.Label>
                    <Form.Select className={'d-inline-block w-auto'} style={{ paddingRight: ' 2.25rem' }} value={size} onChange={(event) => onSizeChange(event)}>
                        <option value={10} >10</option>
                        <option value={20} >20</option>
                        <option value={30} >30</option>
                    </Form.Select>

                </Col>
                <Col >
                    {
                        <GenPaging page_no={cur_page} page_show={5} page_count={page_count} onPageChange={onPagingChange} />
                    }
                </Col>
            </Row>
        </div>
    )
}

export function ToastSuccess({ show = false, closeFc = undefined, message = '' }) {
    return (
        <ToastContainer className="position-fixed bottom-0 end-0 p-3">
            <Toast className="bg-opacity-75 bg-success fs-6 text-white p-2" onClose={() => closeFc(false)} show={show} delay={3000} autohide>
                <Toast.Body>{message}</Toast.Body>
            </Toast>
        </ToastContainer>

    )
}

export function ToastError({ show = false, closeFc = undefined, message = '' }) {
    return (
        <ToastContainer className="position-fixed bottom-0 end-0 p-3">
            <Toast className="bg-opacity-75 bg-danger fs-6 text-white p-2" onClose={() => closeFc(false)} show={show} delay={3000} autohide>
                <Toast.Body>{message}</Toast.Body>
            </Toast>
        </ToastContainer>

    )
}